<tag-input [ngModel]="tags" theme='bootstrap'
    (onRemove)="onRemove($event)"
    (onAdd)="onAdd($event)"

></tag-input>
<!--<span *ngFor="let tag of tags" class="badge bg-secondary me-1">
    {{tag}}
</span>-->
